// extracted by mini-css-extract-plugin
export default {"tabs":"ILwllnqGMRsSG8e7PJfG","styleMatches":"_8q4JnwE5BAvZph5Se44g","tabItem":"Qa72QM_EWxDJKJudozRV","styleMatchesTab":"p9PusWXhm5r4DXmYqSrJ","tabItemActive":"yOHotvqLmLwCesH5M9hd"};